const alphanumericPattern = /^[a-z\d]+$/i;
const hostnameLabelPattern = /^[a-z\d-]+$/i;

const isValidHostname = (hostname: string): boolean => {
  const labels = hostname.split(".");
  const finalLabel = labels.at(-1);

  if (
    labels.length < 2 ||
    labels.some(label => label === "") ||
    !finalLabel ||
    finalLabel.length < 2 ||
    !alphanumericPattern.test(finalLabel)
  ) {
    return false;
  }

  return labels.slice(0, -1).every(label => {
    const firstCharacter = label[0];
    const lastCharacter = label.at(-1);

    return (
      !!firstCharacter &&
      !!lastCharacter &&
      alphanumericPattern.test(firstCharacter) &&
      alphanumericPattern.test(lastCharacter) &&
      hostnameLabelPattern.test(label)
    );
  });
};

// Keeps the legacy schemeless format and its restricted path, query, and fragment
// character sets. Slash-delimited path segments avoid ambiguous nested repetition.
const deprecatedUrlPattern =
  /^(?:https?:\/\/)?([a-z\d.-]+)(?::\d+)?(?:\/[-;:&=+$,\w.]*)*(?:\?[-;:&=+$,\w.%]*)?(?:#[-/\w]*)?$/i;

/** @deprecated Please use isValidURL instead */
export const DEPRECATED_isValidURL = (str: string): boolean => {
  const match = deprecatedUrlPattern.exec(str);

  return !!match && isValidHostname(match[1]);
};

// V2 is using URL class to validate the URL
// but with additional checks that we had in the previous implementation
export const isValidURL = (str: string): boolean => {
  try {
    const url = new URL(str);

    // Do not allow ftp://example.com
    const isValidProtocol =
      url.protocol === "http:" || url.protocol === "https:";

    // Do not allow http://localhost, http://[::1], http://some_invalid_domain
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const isValidDomainOrIP =
      isValidHostname(url.hostname) || ipRegex.test(url.hostname);

    // Do not allow http://user:pass@example.com
    const hasNoAuth = url.username === "" && url.password === "";

    const hasNoSpacesInPath = !url.pathname.includes(" ");

    return (
      isValidProtocol && isValidDomainOrIP && hasNoAuth && hasNoSpacesInPath
    );
  } catch {
    return false;
  }
};
